import type { JSX } from 'react';

/** The design's access switch: 38×22, green when on, a white knob that slides. */
export function Switch({
  on,
  onChange,
  label,
  disabled = false,
  id,
}: {
  on: boolean;
  onChange: (on: boolean) => void;
  label: string;
  disabled?: boolean;
  id?: string;
}): JSX.Element {
  return (
    <button
      id={id}
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={label}
      title={label}
      disabled={disabled}
      onClick={() => onChange(!on)}
      className="relative h-[22px] w-[38px] flex-none rounded-full border-0 p-0 transition-[background] duration-[250ms] disabled:opacity-60"
      style={{ background: on ? 'var(--ok)' : 'var(--line)' }}
    >
      <span
        className="absolute top-[3px] size-4 rounded-full bg-white shadow-[0_1px_3px_rgba(0,0,0,.3)] transition-[left] duration-[250ms]"
        style={{ left: on ? 19 : 3 }}
      />
    </button>
  );
}
